import { type ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useBrand } from "src/hooks/useBrand";

export function LegalIdentity(): ReactElement {
  const { t } = useTranslation();
  const { identity } = useBrand();

  return (
    <>
      {t(
        "{{brandName}} : Société par actions simplifiée au capital de 282 364 800,00 € dont le siège social est à Courbevoie (92400) – Tour Aurore, 18-19 place des Reflets, immatriculée au Registre du Commerce et des Sociétés de Nanterre sous le numéro 890 441 223.",
        { brandName: identity.name },
      )}
    </>
  );
}
